import { render, staticRenderFns } from "./ButtonGo.vue?vue&type=template&id=8026f28c&scoped=true&lang=pug&"
import script from "./ButtonGo.vue?vue&type=script&lang=js&"
export * from "./ButtonGo.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGo.vue?vue&type=style&index=0&id=8026f28c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8026f28c",
  null
  
)

export default component.exports